import React from 'react';
import _ from 'lodash';
import Tooltip from 'rc-tooltip';

import styles from './trendingResearchHeaderStyles';

const TrendingResearchHeader = ({ selectedName, selectionList, handleChange }) => {
  const Icon = _.find(selectionList, selection => selection.name === selectedName).icon;

  return (
    <div className={styles.trendingHeader}>
      <Icon className={`${styles.icon} ${styles.selected}`} />
      <span data-testid="selected" className={styles.selectedText}>
        {selectedName}
      </span>
      {selectionList.map((listItem, idx) => {
        const ListIcon = listItem.icon;
        let iconStyle = `${styles.icon} ${styles.button}`;
        if (listItem.name === selectedName) iconStyle += ` ${styles.selected}`;
        return (
          <Tooltip overlay={listItem.name} placement="top" mouseLeaveDelay={0} key={idx}>
            <ListIcon
              className={iconStyle}
              onClick={handleChange(listItem.name)}
              data-testid={`trending-research-${listItem.name}`}
            />
          </Tooltip>
        );
      })}
    </div>
  );
};

export default TrendingResearchHeader;
